<template>
  <div class="container results">
    <back-and-skip back="thankyou"
      :hideSkip='true'>
    </back-and-skip>
    <div class="row pt-4">
      <div class="col-12 offset-lg-2 col-lg-8">
        <label class="title">
          {{ $t('results.title') }}
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-12 offset-lg-2 col-lg-8 pl-0 pr-0">
        <div class="card">
          <div class="card-body">
            <global-data class="result">
            </global-data>
            <hr>
            <global-map class="result">
            </global-map>
            <hr>
            <age-distribution class="result">
            </age-distribution>
            <hr>
            <have-caught-covid class="result">
            </have-caught-covid>
            <hr>
            <kind-treatment class="result">
            </kind-treatment>
            <hr>
            <take-vaccine class="result">
            </take-vaccine>
            <hr>
            <why-concerned class="result">
            </why-concerned>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackAndSkip from '../components/BackAndSkip.vue'
import GlobalData from './Results/GlobalData.vue'
import GlobalMap from './Results/GlobalMap.vue'
import AgeDistribution from './Results/AgeDistribution.vue'
import HaveCaughtCovid from './Results/HaveCaughtCovid.vue'
import KindTreatment from './Results/KindTreatment.vue'
import TakeVaccine from './Results/TakeVaccinne.vue'
import WhyConcerned from './Results/WhyConcerned.vue'

export default {
  components: {
    BackAndSkip,
    GlobalData,
    GlobalMap,
    AgeDistribution,
    HaveCaughtCovid,
    KindTreatment,
    TakeVaccine,
    WhyConcerned
  },
  async mounted () {
    await this.$store.dispatch('getCOVID19VaccineStats')
  }
}
</script>

<style>
.results {
  background-color: #f5f6fb;
}

.results .title {
  font-weight: 700;
  font-size: 1.6rem;
}

.results .card {
  border-radius: 15px;
}
</style>
